import { useProjectStore, type SheetTab } from "@/store/project-store";
import type { FileEntry } from "./file-index";

/** 지금 편집기에 출처 드로어를 연다. 문서는 문서 화면으로 가고, 다른 플랜이면 그 플랜을 먼저 연다. */
export function openFileInEditor(entry: FileEntry): boolean {
  if (entry.ownerKind === "document") return false;
  const store = useProjectStore.getState();
  if (store.activeId !== entry.projectId && !store.openProject(entry.projectId)) return false;
  const tab: SheetTab = entry.commentId ? "comments" : "attachments";
  const opts = { tab, commentId: entry.commentId };
  if (entry.ownerKind === "task") useProjectStore.getState().setExecutionFocus(entry.ownerId, opts);
  else useProjectStore.getState().setRecordFocus(entry.ownerId, opts);
  return true;
}
